import { render, staticRenderFns } from "./ListTendersView.vue?vue&type=template&id=daf73dc4&"
import script from "./ListTendersView.vue?vue&type=script&lang=js&"
export * from "./ListTendersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports